import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://api.coreviaesg.com",
  headers: {
    "Content-Type": "application/json",
  },
});

// Automatically attach token to every request
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;